import * as Yup from 'yup';
import { CarePlan, MedicalProfessionals } from '../../../types/ndisSection/carePlanInfoTypes';

type CarePlanForm = Partial<CarePlan>;

export const validationSchema: Yup.ObjectSchema<CarePlanForm> = Yup.object().shape({
  Name: Yup.string().trim().optional(),
  PreferredName: Yup.string().trim().optional(),
  Address: Yup.string().trim().optional(),
  Phone: Yup.string().trim().optional(),
  DateOfBirth: Yup.string().trim().optional(),
  MaritalStatus: Yup.string().trim().optional(),
  Nationality: Yup.string().trim().optional(),
  LivingArrangement: Yup.string().trim().optional(),
  NDISNumber: Yup.string().trim().optional(),
  PlanReviewDate: Yup.string().trim().optional(),

  HealthInformation: Yup.object()
    .shape({
      MedicalHistory: Yup.array().of(Yup.string().trim().defined()).optional(),
      Groups: Yup.array()
        .of(
          Yup.object().shape({
            Allergies: Yup.string().trim().optional(),
            CurrentMedications: Yup.string().trim().optional(),
            HealthConditions: Yup.string().trim().optional(),
            PrimaryDiagnosis: Yup.string().trim().optional(),
            FallsRisk: Yup.string().trim().optional()
          })
        )
        .optional()
    })
    .optional(),

  AbilitiesAndSupportNeeds: Yup.object()
    .shape({
      Mobility: Yup.string().trim().optional(),
      Communication: Yup.string().trim().optional(),
      SelfCare: Yup.string().trim().optional(),
      SocialInteraction: Yup.string().trim().optional(),
      SupportNeeds: Yup.string().trim().optional(),
      Continence: Yup.string().trim().optional(),
      Hearing: Yup.string().trim().optional(),
      Vision: Yup.string().trim().optional(),
      Cognition: Yup.string().trim().optional(),
      SwallowingDifficulty: Yup.string().trim().optional(),
      customFields: Yup.object().optional()
    })
    .optional(),

  MealPreferences: Yup.object()
    .shape({
      Likes: Yup.string().trim().optional(),
      Dislikes: Yup.array().of(Yup.string().trim().defined()).optional(),
      DietaryRequirements: Yup.string().trim().optional(),
      PreferredDiet: Yup.string().trim().optional()
    })
    .optional(),

  EmergencyContact: Yup.object()
    .shape({
      Husband: Yup.object()
        .shape({
          Name: Yup.string().trim().optional(),
          Phone: Yup.string().trim().optional()
        })
        .defined(),
      Son: Yup.object()
        .shape({
          Name: Yup.string().trim().optional(),
          Phone: Yup.string().trim().optional()
        })
        .defined()
    })
    .optional(),

  Goals: Yup.object()
    .shape({
      ShortTerm: Yup.array().of(Yup.string().trim().defined()).optional(),
      LongTerm: Yup.array().of(Yup.string().trim().defined()).optional()
    })
    .optional(),

  MedicalProfessionals: Yup.mixed<MedicalProfessionals[]>().optional(),

  RegularAppointments: Yup.array()
    .of(
      Yup.object().shape({
        AppointmentType: Yup.string().trim().optional(),
        Frequency: Yup.string().trim().optional(),
        ContactDetails: Yup.string().trim().optional(),
        Physio: Yup.string().trim().optional()
      })
    )
    .optional(),

  ContingencyAndDisasterPlan: Yup.array()
    .of(
      Yup.object().shape({
        Scenario: Yup.string().trim().optional(),
        RiskLevel: Yup.string().trim().optional(),
        ImmediateAction: Yup.string().trim().optional(),
        OngoingAction: Yup.string().trim().optional()
      })
    )
    .optional(),

  DirectedSupportPlan: Yup.array()
    .of(
      Yup.object()
        .shape({
          CareNeed: Yup.string().trim().optional(),
          FrequencyOfServices: Yup.string().trim().optional(),
          ActionStrategies: Yup.string().trim().optional(),
          VisitTimeDuration: Yup.string().trim().optional(),
          ResponsiblePerson: Yup.string().trim().optional(),
          ByWhen: Yup.string().trim().optional()
        })
        .defined()
    )
    .optional(),

  Medication: Yup.array()
    .of(
      Yup.object().shape({
        Details: Yup.string().optional()
      })
    )
    .optional(),

  Pharmacy: Yup.object()
    .shape({
      Name: Yup.string().trim().optional(),
      Location: Yup.string().trim().optional(),
      Phone: Yup.string().trim().optional()
    })
    .optional(),

  ResponsePlanIfClientNotHome: Yup.string().trim().optional()
});
